import { Profile as ProfileData } from '@news-mono/web-common'
import React, { Fragment } from 'react'
import { BioBlock } from '../../content/BioBlock/BioBlock'
import { StyledMoreTitle } from '../../content/Profile/Profile.styled'

export interface SevenNewsProfileProps {
    profile: ProfileData
    profileUrl: string
}

export const SevenNewsProfile: React.FC<SevenNewsProfileProps> = (props) => {
    return (
        <Fragment>
            <BioBlock
                profile={props.profile}
                url={props.profileUrl}
                title={props.profile.name}
            />
            <StyledMoreTitle>More from {props.profile.name}</StyledMoreTitle>
        </Fragment>
    )
}
